import React, { useEffect } from "react";

const ConfirmationModal = ({
  open,
  onOpenChange,
  title,
  description,
  confirmLabel = "Confirm",
  cancelLabel = "Cancel",
  onConfirm,
  onCancel,
  isLoading = false,
}) => {
    useEffect(() => {
    if (!open) return;

    const handleKeyDown = (e) => {
      if (e.key === "Escape") {
        onOpenChange(false);
        onCancel?.();
      }
    };

    document.addEventListener("keydown", handleKeyDown);

    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [open, onOpenChange, onCancel]);
  
  if (!open) return null;

  const handleOverlayClick = (e) => {
    if (e.target.classList.contains("modal-overlay")) {
      onOpenChange(false);
    }
  };

  return (
    <>
      <style>
        {`
        .modal-overlay {
          position: fixed;
          inset: 0;
          background: rgba(0, 0, 0, 0.4);
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 999;
          animation: fadeIn 0.25s ease-in-out;
        }

        .modal-container {
          width: 90%;
          max-width: 480px;
          background: #fff;
          border-radius: 16px;
          padding: 2rem 1.5rem;
          box-shadow: 0 8px 28px rgba(0, 0, 0, 0.15);
          animation: scaleIn 0.3s ease-in-out;
          display: flex;
          flex-direction: column;
          justify-content: flex-end;
        }

        .modal-header {
          text-align: left;
        }

        .modal-title {
          font-size: 1.5rem;
          font-weight: 600;
          color: #1f2937;
          margin-bottom: 0.75rem;
        }

        .modal-description {
          font-size: 1rem;
          color: #6b7280;
          line-height: 1.6;
        }

        .modal-footer {
          display: flex;
          gap: 0.5rem;
          justify-content: flex-end;
          margin-top: 20px;
          width: 100%;
        }

        .btn {
          padding: 0.5rem 0.75rem; /* ≈ py-2 px-3 */
          border-radius: 10px;   /* matches rounded-lg feel */
          font-size: 0.9rem;
          font-weight: 600;
          cursor: pointer;
          transition: background-color 0.15s ease, opacity 0.15s ease;
          height: 40px;
          display: flex;
          align-items: center;
          justify-content: center;
          white-space: nowrap;
          flex-shrink: 1;
          min-width: 0;
        }

        .btn-outline {
          background: transparent;
          border: 1px solid #d1d5db;
          color: #374151;
        }

        .btn-outline:hover {
          background: #f3f4f6;
        }

        .btn-primary {
          background: #005FCC;
          color: white;
          border: none;
        }
        
        .btn-primary:hover {
          background: #0049A8;
        }

        .btn:disabled {
          opacity: 0.6;
          cursor: not-allowed;
          pointer-events: none;
        }

        @keyframes fadeIn {
          from { opacity: 0; }
          to { opacity: 1; }
        }

        @keyframes scaleIn {
          from { transform: scale(0.95); }
          to { transform: scale(1); }
        }
      `}
      </style>

      <div className="modal-overlay" onClick={handleOverlayClick}>
        <div className="modal-container">
          {/* Header */}
          <div className="modal-header">
            <h6 className="text-[20px] font-semibold text-gray-900">{title}</h6>
            <p className="text-gray-600 text-base leading-relaxed mt-[7px]">{description}</p>
          </div>

          {/* Footer */}
          <div className="modal-footer">
            <button
              className="btn btn-outline"
              onClick={() => {
                onCancel?.();
                onOpenChange(false);
              }}
            >
              {cancelLabel}
            </button>
            <button
              className="btn btn-primary"
              onClick={onConfirm}
              disabled={isLoading}
            >
              {isLoading ? "Processing..." : confirmLabel}
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default ConfirmationModal;
